import {Link} from '@github-ui/react-router'
import {ArrowLeftIcon} from '@primer/octicons-react'
import {Heading} from '@primer/react'
import type {ReactNode} from 'react'
import {useFragment} from 'react-relay'
import {graphql} from 'relay-runtime'

import type {MilestoneTitle$key} from './__generated__/MilestoneTitle.graphql'
import styles from './RepositoryMilestone.module.css'

type MilestoneTitleProps = {
  milestoneRef: MilestoneTitle$key
  children?: ReactNode
}

export function MilestoneTitle({milestoneRef, children}: MilestoneTitleProps) {
  const {title, repository} = useFragment(
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    graphql`
      fragment MilestoneTitle on Milestone {
        title
        repository {
          nameWithOwner
        }
      }
    `,
    milestoneRef,
  )

  const milestonesPath = `/${repository.nameWithOwner}/milestones`

  return (
    <div className={styles.milestoneTitleWrapper}>
      <Link to={milestonesPath} className={styles.backLink}>
        <ArrowLeftIcon />
        Back to Milestones
      </Link>
      <div className={`${styles.buttonGrp} ${styles.header}`}>
        <Heading className={styles.title} as="h2">
          {title}
        </Heading>
        {children ? <div className={styles.actionsGrp}>{children}</div> : null}
      </div>
    </div>
  )
}
